import { hasOwn, treeToList } from '../../utils'
import {
  defaultVxeTableAttrs,
  genRowConfig,
  genTreeConfig,
  defaultPagination,
  defaultTableAttrs,
  genTooltipConfig,
  defaultFooterMethod
} from './config'
import './VxeTable.scss'
export default {
  name: 'VTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    /* columns: 显示和表格项，数组里的每一项都是一个对象，对象中的属性与el-table-column中的属性一一对应 */
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    reload: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      tableAttrs: {},
      vxeTableAttrs: this.getDefaultVxeTableAttrs()
    }
  },
  watch: {
    columns: {
      handler(val) {
        this.init()
      },
      deep: true,
      immediate: false
    },
    data: {
      handler(value) {
        this.init()
        this.$forceUpdate()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 所有复选框是否禁用
    checkboxDisabled() {
      return typeof this.$attrs['is-checked-all'] === 'boolean' && this.$attrs['is-checked-all']
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.proxyVxeTableMethods()
    this.setDefaultSortField()
  },
  methods: {
    getDefaultVxeTableAttrs() {
      return defaultVxeTableAttrs()
    },
    setDefaultSortField() {
      const defaultSort = this.$attrs['default-sort']
      if (defaultSort) {
        const { prop, order } = defaultSort
        /* descending, ascending */
        this.$nextTick(() => {
          this.sort && this.sort(prop, order)
        })
      }
    },
    proxyVxeTableMethods() {
      /* 先拿到所有方法, 对方法作代理  */
      const table = this.$refs.table
      const methods = this._methods = {}
      for (const key in table) {
        if (typeof table[key] === 'function') {
          methods[key] = table[key]
        }
      }

      /* 对Element Table方法进行支持 */
      methods.clearSelection = async() => {
        await methods.clearCheckboxRow()
        if (this.$attrs['checkbox-config']?.reserve) {
          await methods.clearCheckboxReserve()
        }
        return Promise.resolve()
      }
      methods.toggleRowSelection = (...args) => {
        if (args.length === 1) {
          return methods.toggleCheckboxRow(...args)
        } else {
          return methods.setCheckboxRow(...args)
        }
      }
      methods.toggleAllSelection = (...args) => {
        if (args.length === 1) {
          return methods.toggleCheckboxRow(...args)
        } else {
          return methods.setCheckboxRow(...args)
        }
      }
      methods.toggleRowExpansion = (...args) => {
        if (args.length === 1) {
          return methods.toggleRowExpansion(...args)
        } else {
          return methods.setRowExpand(...args)
        }
      }
      methods.doLayout = methods.refreshColum || (() => {})
      const sort = methods.sort
      methods.sort = (prop, order) => {
        if (prop && order) {
          const field = prop
          order = order && order.replace('ending', '')
          return sort(field, order)
        }
      }

      /* 对方法作代理 */
      Object.keys(methods).forEach(key => {
        // proxy(this, '_methods', key)
        this[key] = methods[key]
      })
    },
    /* 渲染多级表头 */
    renderColumnGroup(col) {
      return (
        <vxe-colgroup title={col.label} {...{ props: col }}>
          {this.renderColumn(col.children)}
        </vxe-colgroup>
      )
    },
    renderColumn(columns) {
      const checkboxConfig = this.$attrs['checkbox-config'] || this.vxeTableAttrs['checkbox-config']
      return columns.map((col) => {
        const h = this.$createElement
        /* 表头分组 */
        if (col.children && col.children.length) {
          return this.renderColumnGroup(col)
        }

        let renderFilter; let renderHeader; let renderFooter; let renderDefault; let renderFormatter

        /* 筛选 */
        if (col.renderFilter && typeof col.renderFilter === 'function') {
          renderFilter = (scope) => {
            scope.col = col
            return col.renderFilter(h, scope)
          }
        }

        /* 如果存在自己的renderHeader，则调用自己的renderHeader */
        if (col.renderHeader && typeof col.renderHeader === 'function') {
          renderHeader = (scope) => {
            scope.col = col
            return col.renderHeader
              ? col.renderHeader(h, scope)
              : col.label
          }
        }

        /* 如果存在自己的renderFooter，则调用自己的renderFooter */
        if (col.renderFooter && typeof col.renderFooter === 'function') {
          renderFooter = (scope) => {
            scope.col = col
            return col.renderFooter ? col.renderFooter(h, scope) : null
          }
        }
        /* 如果存在自己的render，则调用自己的render */
        if (col.render && typeof col.render === 'function') {
          renderDefault = (scope) => {
            scope.col = col
            return col.render(h, scope)
          }
        }

        /* 存在formatter函数 */
        if (col.formatter && typeof col.formatter === 'function') {
          renderFormatter = (scope) => {
            scope.col = col
            const isEmpty = value => value === '' || value === null || value === undefined
            const content = col.formatter(scope.row, col)
            const value = !isEmpty(content) ? content : '--'
            return <span>{value}</span>
          }
        }

        /* 排序 */
        if (col.type === 'index' || col.type === 'seq') {
          return (
            <vxe-column
              field={col.prop}
              title={col.label}
              {...{ props: { ...col, type: 'seq', width: col.width || 50 }, scopedSlots: {
                filter: renderFilter,
                header: renderHeader,
                default: renderDefault || renderFormatter,
                footer: renderFooter

              }}}
            ></vxe-column>
          )
        }

        /* 复选框 */
        if (col.type === 'selection' || col.type === 'checkbox') {
          return (
            <vxe-column
              {...{
                props: { ...col, type: 'checkbox', width: col.width || 50 },
                scopedSlots: {
                  filter: renderFilter,
                  default: renderDefault || renderFormatter,
                  footer: renderFooter,
                  header: (scope) => {
                    const { checked, indeterminate, disabled } = scope

                    // 直接使用scope中的值可能会不准确，需要对checked, indeterminate, disabled分别进行计算
                    let _checked = checked
                    let _indeterminate = indeterminate
                    let _disabled = disabled
                    if (this.checkboxDisabled) {
                      _disabled = true
                    }
                    if (checkboxConfig.checkStrictly) {
                      // 对于checkStrictly为true的，选择框状态要单独判断
                      const selectableRows = treeToList(this.$props.data).filter(c => {
                        if (typeof col.selectable === 'function') {
                          return col.selectable({ row: c })
                        }

                        return true
                      })
                      const selection = this.$refs.table.selection
                      _checked = !!selection.length && (selectableRows.length === selection.length)
                      _indeterminate = !!selection.length && (selectableRows.length !== selection.length)
                      _disabled = !selectableRows.length
                    }
                    return (
                      <el-checkbox
                        indeterminate={_indeterminate}
                        disabled={_disabled}
                        value={_checked}
                        onChange={(e) => {
                          this.toggleAllCheckbox(e, checked)
                        }}
                      ></el-checkbox>
                    )
                  },
                  checkbox: (scope) => {
                    const { checked, indeterminate, row, disabled } = scope
                    let _disabled = disabled
                    if (this.checkboxDisabled) {
                      _disabled = true
                    }
                    let checkboxClass = 'el-checkbox__input'
                    let checkboxClickEvent = e => this.handleToggleCheckboxRow(row, e, checked)

                    if (indeterminate) {
                      checkboxClass += ' is-indeterminate'
                    }
                    if (checked) {
                      checkboxClass += ' is-checked'
                    }
                    if (_disabled) {
                      checkboxClass += ' is-disabled'
                      checkboxClickEvent = e => e.stopPropagation()
                    }
                    // if (_disabled) return <span class='el-checkbox__input is-disabled' onClick={(e) => e.stopPropagation()}><span class='el-checkbox__inner'></span></span>
                    // if (indeterminate) return <span class='el-checkbox__input is-indeterminate' onClick={(e) => this.handleToggleCheckboxRow(row, e)}><span class='el-checkbox__inner'></span></span>
                    // if (checked) return <span class='el-checkbox__input is-checked' onClick={(e) => this.handleToggleCheckboxRow(row, e)}><span class='el-checkbox__inner'></span></span>
                    // return <span class='el-checkbox__input'><span class='el-checkbox__inner' onClick={(e) => this.handleToggleCheckboxRow(row, e)}></span></span>
                    return <span
                      class={checkboxClass}
                      onClick={checkboxClickEvent}>
                      <span class='el-checkbox__inner'/>
                    </span>
                  }
                }
              }}
            ></vxe-column>
          )
        }

        /* 展开行 */
        if (col.type === 'expand') {
          return (
            <vxe-column
              {...{
                props: col,
                scopedSlots: {
                  filter: renderFilter,
                  header: renderHeader,
                  footer: renderFooter,
                  default: (scope) => {
                    scope.col = col
                    return col.renderExpand && col.renderExpand(h, scope)
                  },
                  content: (scope) => {
                    scope.col = col
                    return col.render(h, scope)
                  }
                }
              }}
            ></vxe-column>
          )
        }

        return (
          <vxe-column
            field={col.prop}
            title={col.label}
            {...{ props: col, scopedSlots: {
              filter: renderFilter,
              header: renderHeader,
              default: renderDefault || renderFormatter,
              footer: renderFooter

            }}}
          ></vxe-column>
        )
      })
    },
    /* 渲染分页功能 */
    renderPagination() {
      const isPagination = hasOwn(this.$attrs, 'pagination') && this.$attrs.pagination !== false /* 是否分页 */
      /* 如果不分页 */
      if (!isPagination) return null
      const paginationAttrs = this.mergePaginationOptions()
      /* 居左，还是居右 */
      const paginationOffset = this.$attrs['pagination-offset'] || this.$attrs.paginationOffset || 'right'
      const style = {
        textAlign: paginationOffset
      }
      return (
        <el-pagination
          {...{
            props: paginationAttrs,
            on: {
              'size-change': this.handleSizeChange,
              'current-change': this.handleCurrentChange,
              'prev-click': this.handlePrevClick,
              'next-click': this.handleNextClick
            }
          }}
          style={style}
          class='y-pagination-container'
        ></el-pagination>
      )
    },
    handleSizeChange(size) {
      this.$emit('size-change', size)
    },
    handleCurrentChange(current) {
      this.$emit('current-change', current)
    },
    handlePrevClick(current) {
      this.$emit('prev-click', current)
    },
    handleNextClick(current) {
      this.$emit('next-click', current)
    },
    mergePaginationOptions() {
      const attrs = this.$attrs
      const props = {}
      Object.keys(defaultPagination).forEach((key) => {
        props[key] =
            attrs[key] !== undefined ? attrs[key] : defaultPagination[key]
      })
      return props
    },
    async toggleAllCheckbox(e, checked) {
      const checkboxConfig = this.$attrs['checkbox-config'] || this.vxeTableAttrs['checkbox-config']
      // 如果父子不互相关联，全选时需要手动进行选择
      if (checkboxConfig.checkStrictly) {
        const allRows = treeToList(this.$props.data)
        await this.$refs.table.setCheckboxRow(allRows, e)
        await this.$refs.table.setAllCheckboxRow(e)
      } else {
        await this.$refs.table.setAllCheckboxRow(e)
      }
      let selection = this.$refs.table.getCheckboxRecords()
      let reserveSelection = []
      if (this.$attrs['checkbox-config']?.reserve) {
        reserveSelection = this.$refs.table.getCheckboxReserveRecords()
      }
      selection = selection.concat(reserveSelection)
      this.$emit('select-all', selection, !checked)
      this.$emit('selection-change', selection, !checked)
      this.$emit('checkbox-change', selection, !checked)
    },
    handleToggleCheckboxRow(row, e, checked) {
      e.stopPropagation()
      this.$refs.table.toggleCheckboxRow(row)
      let selection = this.$refs.table.getCheckboxRecords()
      let reserveSelection = []
      if (this.$attrs['checkbox-config']?.reserve) {
        reserveSelection = this.$refs.table.getCheckboxReserveRecords()
      }
      selection = selection.concat(reserveSelection)
      /* 获取选中行数据 */
      this.$emit('select', selection, row, !checked)
      this.$emit('selection-change', selection, !checked)
      this.$emit('checkbox-change', selection, !checked)
    },
    setTreeConfig(tableAttrs, key) {
      const treeConfig = (tableAttrs['tree-config'] =
          this.$attrs['tree-config'] || genTreeConfig())
      if (key === 'default-expand-keys') {
        /* 默认展示项 */
        treeConfig.expandRowKeys = this.$attrs[key]
      } else if (key === 'indent') {
        treeConfig.indent = this.$attrs[key]
      } else if (key === 'lazy') {
        treeConfig.lazy = this.$attrs[key]
      } else if (key === 'default-expand-all') {
        /* 默认全部展开 */
        treeConfig.expandAll = this.$attrs[key]
      } else if (key === 'load') {
        treeConfig.load = this.$attrs[key]
      } else if (key === 'tree-props') {
        const treeProps = this.$attrs[key]
        Object.keys(treeConfig).forEach(treeKey => {
          if (treeProps[treeKey] !== undefined) {
            if (treeKey === 'hasChildren') {
              treeConfig.hasChild = treeProps[treeKey] || 'hasChild'
            } else {
              treeConfig[treeKey] = treeProps[treeKey]
            }
          }
        })
      }
    },
    isTreeData(data) {
      return data.some(item => item.children && item.children.length)
    },
    setColumnConfig(tableAttrs, key) {
      const columnConfig = (tableAttrs['column-config'] =
          this.$attrs['column-config'] || this.vxeTableAttrs['column-config'])
      columnConfig.resizable = hasOwn(this.$attrs, key)
    },
    setRowConfig(tableAttrs, key) {
      const rowConfig = (tableAttrs['row-config'] =
          this.$attrs['row-config'] || genRowConfig())
      if (key === 'row-key') {
        rowConfig.keyField = this.$attrs[key] || 'id'
      }
      if (key === 'highlight-current-row') {
        rowConfig.isCurrent = this.$attrs[key] !== false
      }
    },
    setVirtualConfig(tableAttrs) {
      tableAttrs.height = this.$attrs.height || 800
    },
    setTooltipConfig(tableAttrs, key) {
      const tooltipConfig = (tableAttrs['tooltip-config'] =
          this.$attrs['tooltip-config'] || genTooltipConfig())

      tooltipConfig.theme = this.$attrs[key]
    },
    setSummaryConfig(tableAttrs, key) {
      if (key === 'show-summary') {
        tableAttrs['show-footer'] = this.$attrs[key]

        /* 有合计，则不显示分页 */
        tableAttrs.pagination = !(this.$attrs[key] !== false)

        /* 判断是否有summaryMethod */
        const footerMethod = tableAttrs['footer-method']
        if (!footerMethod) {
          tableAttrs['footer-method'] = defaultFooterMethod
        }
      }
      const sumText = this.$attrs['sum-text']
      if (key === 'summary-method') {
        tableAttrs['footer-method'] = (params) => {
          const footerMethod = this.$attrs[key]
          const res = footerMethod(params)
          /* 判断是否是一个二维数组 */
          const isDeep = (arr) => arr.some((item) => item instanceof Array)
          if (isDeep(res)) return res
          if (sumText) {
            res[0] = sumText
          }
          return [res]
        }
      }
    },
    setSpanMethod(tableAttrs, key) {
      const originalSpanMethod = this.$attrs[key]
      if (typeof originalSpanMethod === 'function') {
        tableAttrs[key] = (params) => {
          const res = originalSpanMethod(params)
          if (Array.isArray(res)) {
            const [rowspan, colspan] = res
            return { rowspan, colspan }
          }
          return res
        }
      }
    },
    setSeqConfig(tableAttrs, key) {
      if (typeof this.$attrs[key] === 'function') {
        tableAttrs['seq-config'].seqMethod = (params) => {
          const index = params.seq
          return this.$attrs[key](index)
        }
      }
    },
    initTreeNode() {
      /* 如果是树结构，则添加树的prefix icon */
      if (this.isTreeData(this.data)) {
        const hasTreeNodeCol = this.columns.some(col => col.treeNode)
        if (!hasTreeNodeCol) {
          this.columns[0].treeNode = true
        }
      }
    },
    initTableAttrs() {
      // 获取element table上的属性
      const defaultAttrs = { ...defaultTableAttrs, ...this.vxeTableAttrs }
      const tableAttrs = { ...defaultAttrs }
      Object.keys(defaultAttrs).forEach((key) => {
        if (this.$attrs[key] !== undefined) {
          if (key === 'virtual') {
            this.setVirtualConfig(tableAttrs)
          } else if (
            ['default-expand-keys', 'default-expand-all', 'indent', 'lazy', 'load', 'tree-props'].includes(key)
          ) {
            /* 树表配置 */
            this.setTreeConfig(tableAttrs, key)
          } else if (['row-key', 'highlight-current-row'].includes(key)) {
            // /* 设置rowConfig */
            this.setRowConfig(tableAttrs, key)
          } else if (key === 'resizable') {
            /* 配置column-config */
            this.setColumnConfig(tableAttrs)
          } else if (key === 'fit') {
            tableAttrs['scroll-y'] = { enable: false }
          } else if (key === 'tooltip-effect') {
            /* tooltip配置 */
            this.setTooltipConfig(tableAttrs, key)
          } else if (['show-summary', 'summary-method'].includes(key)) {
            /*  表尾合计行配置 */
            this.setSummaryConfig(tableAttrs, key)
          } else if (key === 'span-method') {
            /* 合并方法配置 */
            this.setSpanMethod(tableAttrs, key)
          } else if (key === 'index') {
            this.setSeqConfig(tableAttrs, key)
          } else {
            tableAttrs[key] = this.$attrs[key]
          }
        }
      })

      this.tableAttrs = tableAttrs
    },
    initFilters(filters) {
      filters.forEach(filter => {
        filter.label = filter.label || filter.text
      })
    },
    initColumns() {
      this.columns.forEach(col => {
        if (col.filters) {
          this.initFilters(col.filters)
        } else if (col.showOverflowTooltip || col['show-overflow-tooltip']) {
          const showOverflow = col.showOverflowTooltip || col['show-overflow-tooltip']
          col.showOverflow = showOverflow
        } else if (col.labelClassName || col['label-class-name']) {
          col.headerClassName = col.labelClassName || col['label-class-name']
        } else if (col.selectable && typeof col.selectable === 'function') {
          const checkboxConfig = this.$attrs['checkbox-config'] || this.vxeTableAttrs['checkbox-config']
          checkboxConfig.checkMethod = col.selectable
        } else
        if (col.reserveSelection || col['reserve-selection']) {
          const checkboxConfig = this.$attrs['checkbox-config'] || this.vxeTableAttrs['checkbox-config']
          checkboxConfig.reserve = col.reserveSelection || col['reserve-selection']
        }
      })
    },
    init() {
      this.initColumns()
      this.initTreeNode()
      this.initTableAttrs()
    }
  },
  render(h) {
    const attrs = this.tableAttrs
    const {
      id,
      height,
      'max-height': maxHeight,
      'auto-resize': autoResize,
      'sync-resize': syncResize,
      stripe,
      border,
      round,
      size,
      loading,
      align,
      'header-align': headerAlign,
      'footer-align': footerAlign,
      'show-header': showHeader,
      'row-class-name': rowClassName,
      'cell-class-name': cellClassName,
      'header-row-class-name': headerRowClassName,
      'header-cell-class-name': headerCellClassName,
      'footer-row-class-name': footerRowClassName,
      'footer-cell-class-name': footerCellClassName,
      'cell-style': cellStyle,
      'header-row-style': headerRowStyle,
      'footer-row-style': footerRowStyle,
      'show-footer': showFooter,
      'footer-method': footerMethod,
      'merge-cells': mergeCells,
      'merge-footer-items': mergeFooterItems,
      'span-method': spanMethod,
      'footer-span-method': footerSpanMethod,
      'show-overflow': showOverflow,
      'show-header-overflow': showHeaderOverflow,
      'show-footer-overflow': showFooterOverflow,
      'keep-source': keepSource,
      'row-key': rowKey,
      'row-id': rowId,
      'column-config': columnConfig,
      'row-config': rowConfig,
      'resizable-config': resizableConfig,
      'seq-config': seqConfig,
      'sort-config': sortConfig,
      'filter-config': filterConfig,
      'export-config': exportConfig,
      'import-config': importConfig,
      'print-config': printConfig,
      'radio-config': radioConfig,
      'checkbox-config': checkboxConfig,
      'tooltip-config': tooltipConfig,
      'expand-config': expandConfig,
      'tree-config': treeConfig,
      'menu-config': menuConfig,
      'clip-config': clipConfig,
      'fnr-config': fnrConfig,
      'mouse-config': mouseConfig,
      'area-config': areaConfig,
      'keyboard-config': keyboardConfig,
      'edit-config': editConfig,
      'valid-config': validConfig,
      rules: rules,
      'edit-rules': editRules,
      'empty-text': emptyText,
      'empty-render': emptyRender,
      'loading-config': loadingConfig,
      'custom-config': customConfig,
      'scroll-x': scrollX,
      'scroll-y': scrollY,
      params: params
    } = attrs

    return (
      <div class='vxe-table-wrapper'>
        <vxe-table
          id={id || rowKey}
          row-id={rowId || rowKey}
          data={this.data}
          height={height}
          max-height={maxHeight}
          auto-resize={autoResize}
          sync-resize={syncResize}
          stripe={stripe}
          border={border}
          round={round}
          size={size}
          loading={loading}
          align={align}
          header-align={headerAlign}
          footer-align={footerAlign}
          show-header={showHeader}
          row-class-name={rowClassName}
          cell-class-name={cellClassName}
          header-row-class-name={headerRowClassName}
          header-cell-class-name={headerCellClassName}
          footer-row-class-name={footerRowClassName}
          footer-cell-class-name={footerCellClassName}
          cell-style={cellStyle}
          header-row-style={headerRowStyle}
          footer-row-style={footerRowStyle}
          show-footer={showFooter}
          footer-method={footerMethod}
          merge-cells={mergeCells}
          merge-footer-items={mergeFooterItems}
          span-method={spanMethod}
          footer-span-method={footerSpanMethod}
          show-overflow={showOverflow}
          show-header-overflow={showHeaderOverflow}
          show-footer-overflow={showFooterOverflow}
          keep-source={keepSource}
          column-config={columnConfig}
          row-config={rowConfig}
          resizable-config={resizableConfig}
          seq-config={seqConfig}
          sort-config={sortConfig}
          filter-config={filterConfig}
          export-config={exportConfig}
          import-config={importConfig}
          print-config={printConfig}
          radio-config={radioConfig}
          checkbox-config={checkboxConfig}
          tooltip-config={tooltipConfig}
          expand-config={expandConfig}
          tree-config={treeConfig}
          menu-config={menuConfig}
          clip-config={clipConfig}
          fnr-config={fnrConfig}
          mouse-config={mouseConfig}
          area-config={areaConfig}
          keyboard-config={keyboardConfig}
          edit-config={editConfig}
          valid-config={validConfig}
          edit-rules={editRules || rules}
          empty-text={emptyText}
          empty-render={emptyRender}
          loading-config={loadingConfig}
          custom-config={customConfig}
          scroll-x={scrollX}
          scroll-y={scrollY}
          params={params}
          ref='table'
          {...{
            on: {
              /* TODO: header-dragend, expand-change 两个事件 */
              'current-change': event => this.$emit('current-change', event),
              'checkbox-all': event => {
                this.$emit('checkbox-all', event)
                this.$emit('select-all', event.records)
              },
              'keydown-start': event => this.$emit('keydown-start', event),
              'keydown': event => this.$emit('keydown', event),
              'keydown-end': event => this.$emit('keydown-end', event),
              'radio-change': event => this.$emit('radio-change', event),
              'checkbox-range-start': event => this.$emit('checkbox-range-start', event),
              'checkbox-range-change': event => this.$emit('checkbox-range-change', event),
              'checkbox-range-end': event => this.$emit('checkbox-range-end', event),
              'cell-click': event => {
                event.$event.stopPropagation()
                this.$emit('cell-click', event)
                this.$emit('row-click', event)
              },
              'cell-dblclick': event => {
                event.$event.stopPropagation()
                this.$emit('cell-dblclick', event)
                this.$emit('row-dblclick', event)
              },
              'cell-menu': event => {
                event.$event.stopPropagation()
                this.$emit('cell-menu', event)
                this.$emit('row-contextmenu', event)
              },
              'cell-mouseenter': event => {
                event.$event.stopPropagation()
                this.$emit('cell-mouseenter', event)
                this.$emit('cell-mouse-enter', event)
              },
              'cell-mouseleave': event => {
                event.$event.stopPropagation()
                this.$emit('cell-mouseleave', event)
                this.$emit('cell-mouse-leave', event)
              },
              'header-cell-click': event => {
                event.$event.stopPropagation()
                this.$emit('header-cell-click', event)
                this.$emit('header-click', event)
              },
              'header-cell-dblclick': event => {
                event.$event.stopPropagation()
                this.$emit('header-cell-dblclick', event)
                this.$emit('header-dblclick', event)
              },
              'header-cell-menu': event => {
                event.$event.stopPropagation()
                this.$emit('header-cell-menu', event)
                this.$emit('header-contextmenu', event)
              },
              'footer-cell-click': event => this.$emit('footer-cell-click', event),
              'footer-cell-dblclick': event => this.$emit('footer-cell-dblclick', event),
              'footer-cell-menu': event => this.$emit('footer-cell-menu', event),
              'clear-merge': event => this.$emit('clear-merge', event),
              'sort-change': event => this.$emit('sort-change', event),
              'clear-sort': event => this.$emit('clear-sort', event),
              'filter-visible': event => this.$emit('filter-visible', event),
              'filter-change': event => this.$emit('filter-change', event),
              'clear-filter': event => this.$emit('clear-filter', event),
              'resizable-change': event => this.$emit('resizable-change', event),
              'toggle-row-expand': event => this.$emit('toggle-row-expand', event),
              'toggle-tree-expand': event => this.$emit('toggle-tree-expand', event),
              'menu-click': event => this.$emit('menu-click', event),
              'cell-selected': event => this.$emit('cell-selected', event),
              'edit-closed': event => this.$emit('edit-closed', event),
              'edit-actived': event => this.$emit('edit-actived', event),
              'edit-disabled': event => this.$emit('edit-disabled', event),
              'valid-error': event => this.$emit('valid-error', event),
              'scroll': event => this.$emit('scroll', event),
              'custom': event => this.$emit('custom', event)

            }}}
        >
          {this.renderColumn(this.columns)}
          <template slot='empty'>
            {emptyRender ? emptyRender() : <y-empty></y-empty>}
          </template>
        </vxe-table>

        {/* {this.renderPagination()} */}
      </div>
    )
  }
}
